import { AtividadeSearchResponse } from "./atividades";
import { BaseService } from "./base";
import { AlunoResponse, TurmaResponse } from "./turmas";

export interface RelatorioNotasDaTurmaResponse {
  alunos: AlunoResponse[];
  atividades: AtividadeSearchResponse[];
  turma: TurmaResponse;
  notas: RelatorioNotasDaTurmaNotaResponse[];
}

export interface RelatorioNotasDaTurmaNotaResponse {
  alunoId: string;
  atividadeId: string;
  nota: number;
  correcoes: RelatorioNotasDaTurmaCorrecaoResponse[];
  grupos: RelatorioNotasDaTurmaGrupoResponse[];
  paginas: RelatorioNotasDaTurmaPaginaResponse[];
  createdAt: string;
}

export interface RelatorioNotasDaTurmaPaginaResponse {
  pageIndex: number;
  nota: number | null;
}

export interface RelatorioNotasDaTurmaGrupoResponse {
  pageIndex: number;
  groupIndex: number;
  completed: boolean;
  reviewed: boolean;
}

export interface RelatorioNotasDaTurmaCorrecaoResponse {
  id: string;
}

class RelatoriosService extends BaseService {
  constructor() {
    super("relatorios");
  }

  notasDaTurma(turma: TurmaResponse): Promise<RelatorioNotasDaTurmaResponse> {
    return this.get("notasDaTurma", { turmaId: turma.id });
  }

  planilhaDeNotas(): Promise<Blob> {
    return this.download("planilhaDasTurmas");
  }
}

export default new RelatoriosService();
